import React from 'react';

import {SidepanelRegisterTabState} from './useFlowchartSidepanelUnsavedChanges';

export interface FlowchartSidepanelUnsavedChangesContextValue {
  registerTab: (params: SidepanelRegisterTabState) => void;
  unregisterTab: (tab: string) => void;
  setIsTabDirty: (tab: string, isDirty: boolean) => void;
}

export const FlowchartSidepanelUnsavedChangesContext =
  React.createContext<FlowchartSidepanelUnsavedChangesContextValue>({
    registerTab: () => {},
    unregisterTab: () => {},
    setIsTabDirty: () => {},
  });
